// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eZzI","question":"styles_question__1aHsi","inputVisibleButton":"styles_inputVisibleButton__qbwqd","note":"styles_note__ywYc0"};